import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  CircularProgress
} from '@mui/material';
import {
  Download,
  PictureAsPdf,
  TableChart
} from '@mui/icons-material';
import { useFeedback } from './EnhancedFeedbackProvider';
import { useDataContext } from '../contexts/DataContext';
import { generatePatientReport } from '../utils/pdfGenerator';
import { generatePatientExcelReport } from '../utils/excelExport';

const ExportButtons = ({ patientId, patientName }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useFeedback();
  const { patients, consultations, vitals, treatments, medicalHistory } = useDataContext();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExport = async (format) => {
    if (!patientId) return;
    
    setLoading(true);
    try {
      // Récupérer les données du patient
      const patient = patients.find(p => p.id === patientId);
      const patientConsultations = consultations.filter(c => c.patientId === patientId);
      const patientVitals = vitals.filter(v => v.patientId === patientId);
      const patientTreatments = treatments.filter(t => t.patientId === patientId);
      const patientMedicalHistory = medicalHistory.filter(h => h.patientId === patientId);
      
      if (!patient) {
        showError('Patient non trouvé');
        return;
      }

      // Générer l'export selon le format
      if (format === 'pdf') {
        generatePatientReport(
          patient,
          patientConsultations,
          patientVitals,
          patientTreatments,
          patientMedicalHistory
        );
        showSuccess(`Dossier PDF généré pour ${patient.firstName} ${patient.lastName}`);
      } else if (format === 'excel') {
        generatePatientExcelReport(
          patient,
          patientConsultations,
          patientVitals,
          patientTreatments,
          patientMedicalHistory
        );
        showSuccess(`Dossier Excel généré pour ${patient.firstName} ${patient.lastName}`);
      }
      
    } catch (error) {
      console.error('Erreur lors de l\'export:', error);
      showError('Erreur lors de l\'export du dossier');
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={loading ? <CircularProgress size={16} /> : <Download />}
        onClick={handleClick}
        disabled={loading}
        sx={{ borderRadius: 2 }}
      >
        Exporter
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={() => handleExport('excel')}>
          <ListItemIcon>
            <TableChart fontSize="small" />
          </ListItemIcon>
          <ListItemText>Exporter en Excel</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={() => handleExport('pdf')}>
          <ListItemIcon>
            <PictureAsPdf fontSize="small" />
          </ListItemIcon>
          <ListItemText>Exporter en PDF</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ExportButtons;
